<template>
  <div id="app" class="min-h-screen bg-white">
    <navigation />
    <div class="py-6">
      <main>
        <div class="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <loading-indicator v-if="loading" class="py-10" size="large" />
          <!-- TODO - ADD ROUTE TRANSITIONS HERE -->
          <router-view />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import LoadingIndicator from "@/components/LoadingIndicator";
import Navigation from "@/components/Navigation";

export default {
  components: {
    Navigation,
    LoadingIndicator,
  },
  computed: {
    loading() {
      return !this.$store.state.initialized;
    },
  },
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
